import React, { useEffect } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import ChatRoutes from './ChatRoutes';
import MeetingRoutes from './MeetingRoutes';
import CallProvider from '../components/CallProvider';
import { CourseRoutes } from './CourseRoutes';
import { TaskRoutes } from './TaskRoutes';
import { ContestRoutes } from './ContestRoutes';
import { AdminRoutes } from './AdminRoutes';
import { ProblemRoutes } from './ProblemRoutes';
import { DocManagementRoutes } from './DocManagementRoutes';
import TimeTableRoutes from './TimeTableRoutes';
import { ResultsRoutes } from './ResultsRoutes';
import useSocketConnection from '../hooks/useSocketConnection';
import GlobalMessageNotifier from '../components/GlobalMessageNotifier';
import ConnectionBanner from '../components/ConnectionBanner';
import socketClient from '../socket';
import RoleBasedRoute from './RoleBasedRoute';

// Lazy load all organization pages
const OrgPlans = LazyComponentWithSuspense(() => import('../pages/Organization/Plans'));
const OrganizationSetting = LazyComponentWithSuspense(
  () => import('../pages/Organization/OrganizationSetting'),
);
const CheckOut = LazyComponentWithSuspense(() => import('../pages/Organization/PlansCheckOut'));
const MemberReport = LazyComponentWithSuspense(() => import('../pages/Organization/MemberReport'));
const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));
const Dashboard = LazyComponentWithSuspense(() => import('../pages/Dashboard'));

export const OrganizationRoutes = ({ setorgImageStatus, orgImageStatus, setAccessStatus }) => {
  const { orgName } = useParams();
  const { isConnected, isReconnecting } = useSocketConnection(orgName);

  useEffect(() => {
    return () => {
      socketClient.disconnect();
    };
  }, []);

  return (
    <>
      <ConnectionBanner isConnected={isConnected} isReconnecting={isReconnecting} />
      <GlobalMessageNotifier />
      <Routes>
        <Route path="problem/*" element={<ProblemRoutes />} />
        <Route path="admin/*" element={<AdminRoutes />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="course/*" element={<CourseRoutes />} />
        <Route path="timetable/*" element={<TimeTableRoutes />} />
        <Route path="doc/*" element={<DocManagementRoutes />} />
        <Route path="task/*" element={<TaskRoutes />} />
        <Route path="contest/*" element={<ContestRoutes />} />
        <Route path="results/*" element={<ResultsRoutes />} />
        <Route path="/chat/*" element={<ChatRoutes />} />
        <Route path="/meet/*" element={<MeetingRoutes />} />
        <Route
          path="/settings"
          element={
            <RoleBasedRoute allowedRoles={['CREATOR', 'SUPERADMIN']} setAccessStatus={setAccessStatus}>
              <OrganizationSetting
                orgImageStatus={orgImageStatus}
                setorgImageStatus={setorgImageStatus}
              />
            </RoleBasedRoute>
          }
        />
        <Route
          path="/checkout/:planId"
          element={
            <RoleBasedRoute allowedRoles={['CREATOR', 'SUPERADMIN']} setAccessStatus={setAccessStatus}>
              <CheckOut />
            </RoleBasedRoute>
          }
        />
        <Route
          path="/plans"
          element={
            <RoleBasedRoute allowedRoles={['CREATOR', 'SUPERADMIN']} setAccessStatus={setAccessStatus}>
              <OrgPlans />
            </RoleBasedRoute>
          }
        />
        <Route
          path="/member/report"
          element={
            <RoleBasedRoute allowedRoles={['CREATOR', 'SUPERADMIN', 'ADMIN']} setAccessStatus={setAccessStatus}>
              <MemberReport />
            </RoleBasedRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};
